// Carousel card dimensions (matches CarouselCard.module.scss breakpoints)
export const CAROUSEL_CARD_WIDTHS = {
  DESKTOP: 374,
  TABLET: 235,
  MOBILE: 114
} as const

// Carousel layout constants
export const CAROUSEL_CONFIG = {
  CARD_MARGIN: 8,
  CONTAINER_PADDING_MULTIPLIER: 1.2,
  MIN_VISIBLE_CARDS: 1,
  DEFAULT_VISIBLE_CARDS: 3,
  DEFAULT_SLIDES_TO_SCROLL: 3,
  SCROLL_THRESHOLD: 3,
  RESIZE_DEBOUNCE_MS: 300,
  ANIMATION_DELAY_MS: 100
} as const

// Animation constants
export const CAROUSEL_ANIMATION = {
  SPEED: 700,
  ENTRANCE_DELAY: 100
} as const
